import formsErrors from "./forms";
import generalErrors from "./general";
import institutionErrors from "./institution";
import departmentErrors from "./department";
import citizenErrors from "./citizen";
import userErrors from "./user";
import documentErrors from "./document";
import registratureErrors from "./registrature";
import uploadErrors from "./upload";
import councilMeetings from "./council-meetings";
import procedureErrors from "./procedures";
import servantErrors from "./servant";

const errorsObj = {
  forms: formsErrors,
  general: generalErrors,
  institution: institutionErrors,
  department: departmentErrors,
  citizen: citizenErrors,
  user: userErrors,
  document: documentErrors,
  registrature: registratureErrors,
  procedure: procedureErrors,
  upload: uploadErrors,
  councilMeetings,
  servant: servantErrors,
};

// generate a type like forms.[keyof forms]
type ErrorsWithPrefix = {
  [key in keyof typeof errorsObj as `${key}.${keyof (typeof errorsObj)[key] &
    string}`]: (typeof errorsObj)[key][keyof (typeof errorsObj)[key]];
};

export const errors = Object.keys(errorsObj).reduce((acc, key) => {
  const errorsForKey = errorsObj[key as keyof typeof errorsObj];
  return {
    ...acc,
    ...Object.keys(errorsForKey).reduce((acc, innerKey) => {
      return {
        ...acc,
        [`${key}.${innerKey}`]: errorsForKey[innerKey as keyof typeof errorsForKey],
      };
    }, {}),
  };
}, {} as ErrorsWithPrefix);

export const isUniqueConstraintError = (error: unknown) => {
  if (!(error instanceof Error)) return false;
  return /duplicate key value violates unique/.test(error.message);
};

export class EptErrorBase {
  constructor(public errorCode: keyof typeof errors) {}
}

export * from "./utils";
